import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  profile: {
    height: '60vw'
  },
  info: {
    paddingLeft: '4vw',
    fontSize: '.9rem'
  },
  label: {
    fontSize: '1.2rem',
    fontWeight: '500',
    marginBottom: '12px',
    color: '#248'
  },
  sublabel: {
    fontSize: '1rem',
    fontWeight: '500',
    margin: '15px 0 5px 0',
    color: '#248'
  }
});
